import "./taggedStudentsForInternship.css";
import { useTranslation } from "react-i18next";

const stepMessageDetails = [
	{
		primaryHeader:
			"internship_selectStudent_pageStepNotification_step1_primaryHeader",
		secondaryHeader1:
			"internship_selectStudent_pageStepNotification_step1_secondaryHeader1",
		secondaryHeader2:
			"internship_selectStudent_pageStepNotification_step1_secondaryHeader2",
		description:
			"internship_selectStudent_pageStepNotification_step1_description",
	},
	{
		primaryHeader:
			"internship_selectStudent_pageStepNotification_step2_primaryHeader",
		secondaryHeader1:
			"internship_selectStudent_pageStepNotification_step2_description",
		description: "",
	},
	{
		primaryHeader:
			"internship_selectStudent_pageStepNotification_step3_primaryHeader",
		secondaryHeader1:
			"internship_selectStudent_pageStepNotification_step3_description",
		description: "",
	},
	{
		primaryHeader:
			"internship_selectStudent_pageStepNotification_step4_primaryHeader",
		secondaryHeader1:
			"internship_selectStudent_pageStepNotification_step4_description",
		description: "",
	},
];

const StepNotification = ({ currentStep }) => {
	const { t } = useTranslation();
	const { primaryHeader, secondaryHeader1, secondaryHeader2, description } =
		stepMessageDetails[currentStep];

	return (
		<div className="stepNotification_container">
			{primaryHeader && (
				<div className="stepNotification_primaryHeader">{t(primaryHeader)}</div>
			)}
			<div className="stepNotification_secondaryHeader_container">
				{secondaryHeader1 && (
					<div className="stepNotification_secondaryHeader">
						{t(secondaryHeader1)}
					</div>
				)}
				{secondaryHeader2 && (
					<div className="stepNotification_secondaryHeader">
						{t(secondaryHeader2)}
					</div>
				)}
			</div>
			{description && (
				<div className="stepNotification_description">
					{t(description)}
					{currentStep === 0 && <span>+ Add</span>}
				</div>
			)}
		</div>
	);
};

export default StepNotification;
